import api from "@/lib/api";

export const money = (cents) => `$${((cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const statusColor = {
  Draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  Approved: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  Issued: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  Sent: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  "Partially Paid": "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Overdue: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  Void: "bg-slate-700/15 text-slate-500 border-slate-700/30",
};

export const TRANSITIONS = {
  Draft: ["Approved", "Void"], Approved: ["Issued", "Draft", "Void"],
  Issued: ["Sent", "Void"], Sent: ["Void"], "Partially Paid": ["Void"], Paid: [], Void: [],
};
export const UNITS = ["Each", "Month", "Subscription", "Hour", "User", "Vessel", "GB", "Custom"];
export const PAYMENT_METHODS = ["Bank Transfer", "Card", "Direct Debit", "Cash", "Other"];

export function InvBadge({ inv, testId }) {
  const label = inv.overdue ? "Overdue" : inv.status;
  const cls = statusColor[label] || statusColor.Draft;
  return <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${cls}`}>{label}</span>;
}

export async function openInvoicePdf(id) {
  const res = await api.get(`/invoices/${id}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
